import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError, Subject, Observable } from 'rxjs';

export interface ApiResponse {
  isError?: any;
  Description?: any;
  result?: any;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  // endpoint: string = 'http://localhost:9201/nest-fatek/';
  endpoint: string = 'https://fatekcare.fi.co.th/nest-fatek/';
  endpointApi: string = 'https://fatekcare.fi.co.th/fatek/';
  //endpointApi:string = 'http://localhost:51045/';
  private jwtError = new Subject<boolean>();

  constructor(
    private http: HttpClient
  ) {
    this.jwtError.next(false);
  }

  requestPost(url: string, body?: any) {
    return this.http.post<any>(`${this.endpoint}${url}`, body).pipe(
      map((res: Response) => {
        if (this.jwtCheck(res)) return res || {}
      }),
      catchError(this.handleError)
    ).toPromise() as Promise<ApiResponse>;
  }

  requestPostBlob(url: string, body?: any) {
    return this.http.post(`${this.endpoint}${url}`, body, {
      responseType: "blob",
      headers: new HttpHeaders().append("Content-Type", "application/json")
    });
  }
  requestPostApi(url: string, body?: any){
    return this.http.post<any>(`${this.endpointApi}${url}`, body).pipe(
      map((res: Response) => {
        if (this.jwtCheck(res)) return res || {}
      }),
      catchError(this.handleError)
    ).toPromise() as Promise<ApiResponse>;
  }

  jwtCheck(res: any): boolean {
    if (res.isError == true) {
      if (res.Description == "Unauthorized" || res.Description == "JWT expire") {
        this.jwtError.next(true);
      }
    }
    return true;
  }

  setJwtError(jwtError: boolean) {
    this.jwtError.next(jwtError);
  }

  getJwtError(): Observable<boolean> {
    return this.jwtError.asObservable();
  }

  // Error 
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }

}